import { render, staticRenderFns } from "./AmountAnalisysChart.vue?vue&type=template&id=453ac9df&scoped=true&"
import script from "./AmountAnalisysChart.vue?vue&type=script&lang=js&"
export * from "./AmountAnalisysChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453ac9df",
  null
  
)

export default component.exports